<button (click)="closeModal()"
        [tabIndex]="tabIndex"
        aria-label="Close" class="close close_modal close_modal_{{modalSize}}"
        data-action="closeModal"
        type="button">
    <span aria-hidden="true">&times;</span>
</button>
